import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16 22H4C2.89543 22 2 21.1046 2 20V8H4V20H16V22ZM20 18H8C6.89543 18 6 17.1046 6 16V4C6 2.89543 6.89543 2 8 2H20C21.1046 2 22 2.89543 22 4V16C22 17.1046 21.1046 18 20 18ZM8 4V16H20V4H8ZM13 13.561L9.293 9.853L10.707 8.439L13 10.733L17.293 6.44L18.707 7.854L13 13.56V13.561Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SelectMultiple"
);
